<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="2486.000000pt" height="2732.000000pt" viewBox="0 0 2486.000000 2732.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,2732.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M5859 27310 c-220 -22 -467 -113 -695 -256 -123 -77 -153 -92 -231
-110 -96 -23 -267 -15 -348 16 -282 105 -404 133 -595 133 -406 2 -729 -186
-1081 -628 -108 -135 -175 -202 -267 -264 -94 -64 -131 -75 -442 -141 -525
-112 -760 -177 -936 -259 -270 -127 -395 -304 -449 -637 -24 -143 -37 -468
-30 -729 46 -1793 146 -4489 391 -10515 48 -1187 51 -1398 19 -1580 -64 -362
-221 -588 -565 -813 -125 -81 -223 -175 -285 -271 -146 -228 -267 -604 -295
-916 -21 -242 -32 -1135 -37 -3050 -5 -1992 8 -3790 27 -3985 29 -288 93 -511
176 -621 15 -20 55 -54 88 -77 369 -248 609 -537 750 -904 111 -287 157 -678
126 -1081 -10 -125 -9 -135 11 -182 24 -56 89 -121 146 -146 59 -26 176 -24
240 5 94 42 180 160 202 277 24 127 33 407 26 812 l-7 412 3066 0 c1686 0
3066 -3 3066 -7 1 -5 5 -150 10 -323 9 -337 23 -470 66 -618 31 -107 60 -158
120 -210 63 -56 125 -75 227 -70 99 4 161 31 224 95 73 75 83 120 83 362 0
354 35 562 124 746 111 228 279 384 575 536 84 42 120 68 181 129 91 91 172
210 239 351 95 199 126 328 136 559 7 171 18 255 46 369 97 391 361 619 849
736 391 93 449 111 915 280 171 62 447 158 615 213 168 55 974 321 1791 591
818 270 1491 491 1496 491 5 0 17 -51 27 -113 201 -1273 472 -2387 776 -3192
638 -1691 1553 -2515 2980 -2684 281 -34 771 -43 1050 -21 1393 110 2630 762
3456 1821 483 618 802 1389 903 2179 40 306 46 691 16 953 -57 490 -161 911
-332 1342 -401 1013 -1094 1773 -2028 2224 -742 359 -1625 548 -2925 625 -380
23 -413 25 -416 29 -12 12 107 376 161 495 l34 72 1393 0 c772 0 1458 5 1538
10 537 35 1012 251 1395 635 335 334 535 722 638 1235 l21 105 4 3825 c2 2737
0 3853 -8 3925 -85 771 -542 1446 -1208 1783 -200 101 -356 155 -597 205
l-100 21 -3690 3 c-4079 4 -3784 8 -4056 -61 -775 -195 -1391 -824 -1595
-1630 -14 -56 -35 -157 -47 -226 l-21 -125 -3 -3710 c-4 -3774 -3 -3902 33
-4110 110 -637 472 -1194 999 -1537 187 -122 453 -236 672 -287 232 -54 228
-54 1251 -58 l953 -4 -90 -175 c-238 -458 -388 -670 -555 -782 -79 -53 -260
-123 -891 -347 -877 -311 -1744 -589 -3695 -1183 -542 -166 -1138 -348 -1325
-406 -187 -58 -345 -106 -351 -106 -21 0 -33 2203 -14 2610 27 555 23 780 -16
1050 -115 797 -539 1278 -1318 1491 l-116 32 7 351 c5 193 8 635 8 981 0 535
-3 659 -19 825 -32 345 -23 607 30 849 77 348 231 622 487 867 169 162 303
253 612 415 763 400 1234 921 1465 1618 117 351 156 650 147 1110 -6 317 -18
436 -88 849 -58 344 -91 609 -119 967 -41 522 -65 738 -105 960 -72 392 -187
602 -411 751 -223 148 -522 231 -1371 379 l-32 6 -4 1222 c-4 1262 -5 1273
-48 1502 -87 460 -320 772 -685 915 -221 86 -393 110 -799 110 -315 0 -405 9
-487 51 -25 12 -87 67 -148 132 -169 178 -318 295 -487 382 -196 101 -418 146
-624 125z m269 -766 c138 -30 264 -126 329 -249 43 -82 79 -211 93 -331 7 -68
12 -797 15 -2324 2 -1224 8 -2301 13 -2395 7 -125 15 -189 31 -240 12 -38 77
-179 144 -312 l121 -241 42 76 c22 42 66 119 98 170 76 125 129 232 157 317
l23 70 7 1600 c7 1858 16 2148 73 2360 88 327 311 685 485 779 46 25 67 29
160 34 125 5 196 -7 281 -49 147 -74 233 -223 276 -479 17 -98 18 -254 19
-2360 2 -2540 9 -3347 31 -3454 20 -102 52 -177 172 -408 l107 -206 70 121
c233 403 245 436 265 701 6 82 15 408 20 725 14 881 32 998 185 1183 257 313
743 271 916 -78 28 -56 36 -97 84 -436 124 -871 180 -1399 205 -1948 13 -280
13 -653 0 -760 -35 -283 -192 -615 -412 -870 -106 -123 -213 -204 -391 -297
-1093 -573 -1710 -1397 -1896 -2533 -70 -424 -79 -966 -26 -1475 35 -327 37
-380 30 -792 l-7 -413 -2907 0 -2906 0 -37 51 c-42 57 -45 71 -53 274 -3 77
-37 844 -75 1705 -92 2069 -206 4655 -335 7595 -58 1320 -110 2443 -116 2495
-6 52 -9 152 -7 222 4 127 4 128 46 210 65 124 185 299 244 355 292 275 742
189 922 -177 38 -78 48 -110 56 -180 25 -227 33 -619 40 -2000 l6 -1465 27
-90 c24 -81 253 -563 268 -564 3 -1 12 14 21 32 9 18 56 98 105 177 183 295
192 321 205 605 5 121 13 1183 17 2360 8 2138 8 2140 29 2230 53 220 172 366
349 424 144 48 370 48 510 0 171 -57 287 -191 337 -385 39 -155 39 -161 41
-2269 2 -1239 7 -2124 13 -2255 14 -283 20 -306 217 -762 l68 -156 113 229
c183 371 210 449 226 659 6 82 13 1014 17 2395 l8 2260 21 90 c69 286 239 438
522 465 91 9 204 3 288 -16z m15038 -6244 c364 -93 635 -429 699 -870 14 -93
15 -532 12 -3845 l-3 -3740 -21 -85 c-12 -47 -35 -123 -52 -169 -104 -285
-313 -503 -569 -595 l-87 -31 -3130 0 -3130 0 -69 23 c-332 111 -560 391 -653
802 -16 70 -17 336 -21 3775 -2 2597 0 3732 8 3807 47 472 340 850 724 933 50
11 612 14 3137 14 3049 1 3076 1 3155 -19z m2059 -1410 c151 -39 275 -118 385
-247 185 -216 224 -560 95 -828 -268 -557 -1041 -551 -1306 11 -54 113 -72
197 -72 329 0 132 18 216 72 329 97 206 269 351 481 406 102 26 243 26 345 0z
m-9365 -735 l0 -445 -265 0 -265 0 0 445 0 445 265 0 265 0 0 -445z m9395
-1585 c255 -80 456 -300 511 -559 21 -99 18 -262 -6 -357 -69 -269 -271 -479
-527 -545 -108 -28 -261 -27 -363 1 -413 116 -646 567 -506 978 43 125 84 190
186 293 83 84 107 102 190 142 52 25 127 53 165 61 97 22 257 15 350 -14z
m-17425 -5249 c1597 -89 2735 -333 3305 -708 85 -56 196 -146 203 -165 2 -4
-1100 -9 -2450 -10 -2286 -3 -2455 -4 -2484 -20 -43 -23 -89 -79 -104 -124 -8
-22 -11 -66 -8 -110 9 -143 83 -238 234 -303 135 -58 360 -129 465 -146 149
-24 1503 -38 2982 -29 l1247 7 0 -2765 0 -2765 -122 -16 c-188 -25 -405 -46
-602 -57 -264 -15 -1001 -12 -1581 6 -553 17 -1390 15 -1635 -5 -318 -26 -545
-56 -812 -107 l-188 -36 1 -37 c0 -20 10 -121 22 -226 l22 -190 2453 -3 c1420
-1 2452 -6 2452 -11 0 -17 -87 -126 -137 -172 -381 -354 -1282 -622 -2533
-753 -525 -55 -890 -75 -1505 -83 -1711 -20 -3181 193 -3934 571 -155 78 -339
213 -392 287 l-21 30 718 -7 c696 -6 1159 2 1347 26 132 16 242 100 288 218
30 77 32 196 4 271 -27 73 -100 152 -167 181 -91 39 -234 44 -1235 44 l-933 1
0 2796 0 2796 868 -1 c1142 -1 1193 3 1298 109 70 70 98 142 97 255 -1 128
-48 228 -136 288 -118 81 -201 87 -1274 86 l-872 0 20 27 c31 44 127 126 214
183 553 366 1777 611 3375 676 267 10 1261 5 1510 -9z m12636 -1668 c-178
-357 -406 -882 -549 -1263 -327 -875 -501 -1627 -579 -2500 -17 -192 -17 -985
0 -1170 35 -372 69 -601 123 -813 306 -1217 1125 -2002 2271 -2178 171 -27
539 -36 728 -20 849 75 1612 513 2142 1228 314 423 522 946 583 1469 20 170
20 506 0 661 -151 1160 -1157 2040 -2553 2233 -274 38 -424 45 -932 45 -272 0
-672 -4 -889 -9 l-394 -8 6 168 c12 329 75 537 212 704 151 183 400 272 720
257 123 -6 872 -96 1186 -142 671 -100 1162 -245 1664 -490 394 -193 715 -416
1003 -699 549 -538 852 -1163 954 -1966 8 -69 13 -219 13 -440 -1 -287 -4
-358 -23 -495 -83 -612 -276 -1126 -620 -1650 -618 -943 -1587 -1603 -2627
-1791 -162 -29 -335 -45 -555 -51 -917 -24 -1747 248 -2435 797 -164 131 -420
387 -550 550 -489 611 -788 1346 -894 2190 -69 554 -64 1274 14 1920 136 1120
510 2290 1087 3398 l90 172 429 0 429 0 -54 -107z m-2446 -1833 c58 -49 105
-93 105 -97 -1 -5 -37 -82 -82 -173 -44 -91 -115 -235 -156 -322 -113 -237
-197 -358 -290 -422 -56 -38 -210 -96 -862 -323 -784 -272 -1501 -507 -3210
-1052 -621 -198 -1186 -378 -1255 -400 l-125 -40 -144 144 -145 144 28 38 c16
21 81 119 146 218 239 363 303 442 418 518 73 49 339 147 1292 478 679 235
4119 1376 4155 1378 12 0 64 -37 125 -89z m3560 -1070 c168 -28 442 -72 610
-100 496 -81 735 -143 1075 -279 554 -222 924 -522 1116 -903 173 -343 203
-849 80 -1324 -165 -631 -599 -1139 -1261 -1473 -602 -305 -1139 -366 -1664
-190 -345 115 -706 368 -918 645 -333 435 -592 1116 -685 1804 -28 208 -26
651 4 815 31 169 66 284 123 400 80 165 193 269 406 373 75 36 750 273 799
281 5 0 147 -22 315 -49z"/>
</g>
</svg>
